import moment from "moment";

export const formatBytes = function (bytes) {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (!bytes || bytes < 0) return '0 Bytes';
  var i = Math.min(Math.max(Math.floor(Math.log(bytes) / Math.log(1024)), 0), sizes.length - 1);
  return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + ' ' + sizes[i];
};

// "1h 2m 3s". Ordinary durations are formatted directly, because the library call below takes
// about 0.14 ms and the table search formats every row (9000+ content records = over a second).
// Whole minutes with a fraction of half a second or more are left to the library: it prints
// them its own way (60.5 s is "1m"), and the output has to stay the same as it always was.
export const formatSeconds = function (seconds) {
  if (!seconds) {
    return '0s';
  }
  if (typeof seconds === "number" && seconds >= 1 && seconds < 360000) {
    const whole = Math.floor(seconds);
    if (!(whole % 60 === 0 && seconds - whole >= 0.5)) {
      const total = Math.round(seconds);
      const parts = [];
      if (total >= 3600) parts.push(Math.floor(total / 3600) + "h");
      if (total % 3600 >= 60) parts.push(Math.floor((total % 3600) / 60) + "m");
      if (total % 60 > 0) parts.push((total % 60) + "s");
      return parts.join(" ");
    }
  }
  return moment.duration(seconds, "seconds").format("h[h] m[m] s[s]", { trim: "both mid" });
};

export const tokenFilterOld = function (token, query) {
  return token.toLowerCase().includes(query.toLowerCase())
}

export const tokenFilter = (value, query) => {
  if (!query) return true
  
  const queryTokens = query.toLowerCase().split(/\s+/)
  const valueTokens = String(value).toLowerCase().split(/\s+/)

  return queryTokens.every(vt => valueTokens.some(rt => rt.includes(vt)))
}


export const sanitize = function (filename) {
  if (!filename) {
      return "";
  }

  // Replace invalid characters with an underscore
  // Covers / \ : ? " “ ” < > | * NUL, control characters (ASCII 0-31), and # % & { }
  let sanitized = filename.replace(/[\/\\:?"\u201C\u201D<>|*\x00-\x1F#%&{}]/g, "_");

  // Remove leading/trailing spaces and dots
  sanitized = sanitized.trim().replace(/^\.+|\.+$/g, "");

  // Replace sequences of underscores with a single underscore
  sanitized = sanitized.replace(/_+/g, "_");

  // Handle reserved directory names (. and ..)
  if (sanitized === "." || sanitized === "..") {
      sanitized = "_" + sanitized;
  }

  // Lowercase the extension so MIME inference and transcoding work
  // consistently (e.g. "video.MP4" -> "video.mp4", "photo.JPG" -> "photo.jpg")
  sanitized = sanitized.replace(/\.([^.]+)$/, (m, ext) => "." + ext.toLowerCase());

  // Ensure filename is not empty after sanitization
  if (sanitized.length === 0) {
      sanitized = "unnamed";
  }

  // Truncate to 255 characters to comply with FAT32 limits
  if (sanitized.length > 255) {
      sanitized = sanitized.substring(0, 255);
  }

  return sanitized;
}

// Build a collision-proof filename by injecting a unique token before the
// extension, e.g. uniqueFilename("video.mp4", "<id>") => "video-<id>.mp4".
// Two content records that share a display name still get distinct filenames,
// so consumers that key off basename (e.g. the Android player playlists) don't
// overwrite each other. Keep the original name as `displayName` for the UI.
export const uniqueFilename = function (filename, token) {
  const sanitized = sanitize(filename)
  const dot = sanitized.lastIndexOf(".")
  if (dot <= 0) {
      return token ? sanitized + "-" + token : sanitized
  }
  const base = sanitized.substring(0, dot)
  const ext = sanitized.substring(dot)
  return token ? base + "-" + token + ext : sanitized
}

// Schedule dates are stored as an ISO-8601 instant in UTC (e.g.
// "2026-10-07T08:00:00.000Z"), so they mean the same moment in every time zone;
// the Cloud Function runs in UTC. Older records hold a date-only string
// ("2026-10-07"), which the function reads as UTC midnight.
export const parseScheduleDate = function (value) {
  if (!value) return null
  const parsed = /^\d{4}-\d{2}-\d{2}$/.test(value) ? moment.utc(value, "YYYY-MM-DD", true) : moment(value, moment.ISO_8601, true)
  return parsed.isValid() ? parsed.local() : null
}

// Local date and time (browser time zone), e.g. "2026-10-07 10:00".
export const formatScheduleDate = function (value) {
  const parsed = parseScheduleDate(value)
  return parsed ? parsed.format("YYYY-MM-DD HH:mm") : (value || "")
}